<template>
  <div class="home">
    <BackButton @click="goBack" />
    <div class="slider-block">
      <div class="slider"></div>
      <p class="activeBlock" @click="changeActive">{{ $t("finances") }}</p>
      <p @click="changeActive">{{ $t("trades") }}</p>
    </div>
    <div class="notificationsList" v-if="activeMode == 'finances'">
      <p v-if="transactions.length == 0">{{ $t("historyEmpty") }}</p>
      <div class="notify" v-for="item of transactions" :key="item">
        <div class="notifyText">
          <div class="notifyHead">
            <p>
              {{ $t("deposit2") }}, <span>{{ $t("bankCard") }} RUB</span>
            </p>
          </div>
          <div class="notifySum">
            <p class="notifySumText success">+1 000 ₽</p>
          </div>
        </div>
        <div class="notifyTime">
          <p>18:23</p>
        </div>
      </div>
    </div>
    <div class="notificationsList" v-if="activeMode == 'trades'">
      <p v-if="games.length == 0">{{ $t("historyEmpty") }}</p>
      <div class="notify" v-for="item of games" :key="item">
        <div class="notifyText">
          <div class="notifyHead">
            <p>{{ item.result == 1 ? $t("win") : $t("lose") }}</p>
          </div>
          <div class="notifySum">
            <p class="notifySumText" :class="item.result ? 'success' : 'lose'">{{ item.result == 1 ? "+" : "-" }} {{ item.summ }} ₽</p>
          </div>
        </div>
        <div class="notifyTime">
          <p>{{ formatTimestamp(item.date) }}</p>
        </div>
      </div>
      <!-- <div class="notify">
        <div class="notifyText">
          <div class="notifyHead">
            <p>{{ $t("lose") }}</p>
          </div>
          <div class="notifySum">
            <p class="notifySumText lose">-1 000 ₽</p>
          </div>
        </div>
        <div class="notifyTime">
          <p>10.02.2025</p>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { BackButton } from "vue-tg";
import { UserManager } from "@/utils/userManager";
import { getDateLocale } from "@/utils/apiErrors";
import axios from "axios";
export default {
  name: "NotificationsPage",
  data() {
    return {
      activeMode: "finances",
      botId: null,
      user: null,
      transactions: [],
      games: [],
    };
  },
  methods: {
    goBack() {
      window.history.back();
    },
    changeActive() {
      let slider = document.querySelector(".slider");
      let p = document.querySelectorAll(".slider-block p");
      for (let ps of p) {
        ps.className = "";
      }
      if (this.activeMode == "finances") {
        slider.classList.add("move-right");
        p[1].className = "activeBlock";
        this.activeMode = "trades";
        // this.getTrades()
      } else {
        slider.className = "slider";
        p[0].className = "activeBlock";
        this.activeMode = "finances";
        // this.getFinances()
      }
    },
    async getFinances() {
      try {
        const response = await axios.get(`${window.location.origin}/user/finances/${this.botId}/${this.user.id}`);
        console.log(response);
        this.transactions = response.data.transactions;
      } catch (err) {
        console.log(err);
      }
    },
    async getTrades() {
      try {
        const response = await axios.get(`${window.location.origin}/user/games/${this.botId}/${this.user.id}`);
        console.log(response);
        this.games = response.data.games;
      } catch (err) {
        console.log(err);
      }
    },
    isToday(timestamp) {
      const now = new Date();
      const date = new Date(timestamp * 1000);

      return date.getDate() === now.getDate() && date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear();
    },
    formatTimestamp(timestamp) {
      const date = new Date(timestamp * 1000);
      const lang = getDateLocale(this.$store.getters.getLanguage);

      if (this.isToday(timestamp)) {
        // Только время: "15:30"
        return date.toLocaleTimeString(lang, { hour: "2-digit", minute: "2-digit" });
      } else {
        // Формат DD.MM.YY
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Месяцы с 0
        const year = String(date.getFullYear()).slice(-2); // Последние 2 цифры года

        return `${day}.${month}.${year}`;
      }
    },
    initializeUser() {
      // Получаем данные пользователя из store или инициализируем заново
      const storedUser = this.$store.getters.getTgUserData;
      const storedBotId = this.$store.getters.getBotId;

      if (storedUser && storedBotId) {
        this.user = storedUser;
        this.botId = storedBotId;
        console.log("Данные пользователя из store:", this.user, this.botId);
      } else {
        const userContext = UserManager.getFullUserContext();
        this.user = userContext.user;
        this.botId = userContext.botId;
        this.$store.commit("setTgUserData", this.user);
        this.$store.commit("setBotId", this.botId);
        console.log("Новые данные пользователя:", this.user, this.botId);
      }
    },
  },
  mounted() {
    this.initializeUser();
    this.getFinances();
    this.getTrades();
  },
  components: { BackButton },
};
</script>

<style scoped>
.home {
  padding: 5% 3% 5% 3%;
  display: flex;
  flex-direction: column;
  gap: 2vh;
  background-color: var(--background-color);
  height: 100vh;
  max-width: 100vw;
}
.slider-block {
  font-size: 14px;
  display: flex;
  margin: 0 auto;
  background-color: var(--button-background);
  border-radius: 50px;
  position: relative;
  padding: 5px 10px 5px 10px;
}
.slider-block p {
  padding: 5px 20px 5px 20px;
  flex: 1;
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: center;
  z-index: 1;
  color: #737376;
  cursor: pointer;
  user-select: none;
}
.slider {
  background-color: var(--slider-color);
  width: 50%;
  height: 70%;
  position: absolute;
  left: 3%;
  top: 50%;
  transform: translateY(-50%);
  z-index: 0;
  border-radius: 50px;
  transition: left 0.4s, width 0.5s;
}
.slider.move-right {
  left: 49%;
  width: 49%;
}
.activeBlock {
  color: var(--text-color1) !important;
}
.notify {
  background-color: var(--second-color);
  border-radius: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding: 3%;
}
.notifyText {
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 6px;
}
.notifyHead p span {
  color: #808080;
}
.notifyHead {
  font-size: 17px;
}
.notifyTime {
  font-size: 14px;
  color: #808080;
}
.notifySumText {
  font-size: 15px;
}
.notifySumText.success {
  color: #27c12d;
}
.notifySumText.lose {
  color: #ff3535;
}
.notificationsList {
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
}
</style>
